import React from 'react';
import Hero from '../components/sections/Hero';
import PricingTable from '../components/sections/PricingTable';
import AEOSOP from '../components/sections/AEOSOP';
import FAQSection from '../components/sections/FAQSection';
import SEO from '../components/common/SEO';
import SafeIcon from '../components/common/SafeIcon';
import { FiShield, FiTrendingUp, FiCpu, FiCheckCircle } from 'react-icons/fi';

const PricingPage = () => {
  const pricingDefinition = "AlbertaRank pricing is based on the complexity of your local entity authority. We offer three tiers—Foundation, Growth, and Dominator—each utilizing the Truth Protocol™ to ensure your home service business captures maximum revenue from Google Maps and AI search engines.";

  return (
    <>
      <SEO 
        title="SEO & AEO Pricing Plans | AlbertaRank™" 
        description="Transparent pricing for Alberta's leading SEO and AEO services. Choose the plan that fits your growth goals, from Local Foundation to Market Dominator."
      />
      
      <Hero 
        title="Predictable Cost. Explosive Growth." 
        subtitle="No hidden fees. No vanity metrics. Just pure local dominance and AI visibility for Alberta's top contractors."
        definition={pricingDefinition}
      />

      <section className="py-12 bg-slate-50 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-8 md:gap-16">
            <div className="flex items-center gap-3">
              <SafeIcon icon={FiShield} className="text-orange-600 text-xl" />
              <span className="font-bold text-slate-700">Month-to-Month</span>
            </div>
            <div className="flex items-center gap-3">
              <SafeIcon icon={FiCheckCircle} className="text-orange-600 text-xl" />
              <span className="font-bold text-slate-700">Truth Protocol™ Verified</span>
            </div>
            <div className="flex items-center gap-3">
              <SafeIcon icon={FiTrendingUp} className="text-orange-600 text-xl" />
              <span className="font-bold text-slate-700">ROI Focused Reports</span>
            </div>
          </div>
        </div>
      </section>

      <PricingTable />

      <AEOSOP city="Alberta" />

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-slate-900 rounded-[3rem] p-12 md:p-20 text-white relative overflow-hidden">
            <div className="absolute top-0 right-0 p-12 opacity-10">
              <SafeIcon icon={FiCpu} className="text-[200px]" />
            </div>
            
            <div className="relative z-10 max-w-3xl">
              <h2 className="text-3xl md:text-5xl font-black mb-8 leading-tight">
                Not sure which plan fits your current scale?
              </h2>
              <p className="text-xl text-slate-400 mb-10 leading-relaxed">
                Most contractors start with the **Growth Engine** to capture the immediate AI search shift. We recommend a free audit first to see your current "Truth Score."
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button className="px-8 py-4 bg-orange-600 hover:bg-orange-700 text-white rounded-xl font-black transition-all">
                  Get My Free Audit
                </button>
                <button className="px-8 py-4 bg-white/10 hover:bg-white/20 text-white rounded-xl font-black transition-all border border-white/10">
                  Book a Discovery Call
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FAQSection />
    </>
  );
};

export default PricingPage;